<template>
  <v-card class="tooltip pl-0 ml-0" flat>
    <v-card-title class="portal-deep-blue-bg">
      <v-icon color="#fff" size="20"> mdi-train </v-icon>
      {{ point.locomotive.locomotive }}
    </v-card-title>
    <v-card-text class="pl-0 ml-0">
      <v-row>
        <v-col class="col-1 pt-4">
          <v-icon color="#00475A" size="18"> mdi-map-marker </v-icon>
        </v-col>
        <v-col class="pb-0">
          <span>{{ $t("message.page.locate", { value: "default" }) }}</span
          ><br />
          <b>{{ point.locomotive.city }}</b>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-1 pt-0 pb-0">
          <v-icon color="#00475A" size="18"> mdi-file </v-icon>
        </v-col>
        <v-col class="pb-0 pt-0">
          <span>{{
            $t("message.page.contractStatus", { value: "default" })
          }}</span
          ><br />
          <b>{{ point.asset.contractualStatus }}</b>
        </v-col>
      </v-row>
      <v-row>
        <div class="col-1 pt-0 pb-0">
          <v-icon color="#00475A" size="18"> mdi-train </v-icon>
        </div>
        <div class="col pt-0 pb-2">
          <span>{{ $t("message.page.status", { value: "default" }) }}</span
          ><br />
          <b>{{ point.asset.status }}</b>
        </div>
      </v-row>
      <v-row>
        <div class="col-1 pt-0 pb-0">
          <v-icon color="#00475A" size="18"> mdi-battery </v-icon>
        </div>
        <div class="col pt-0 pb-2">
          <span>Battery level (V)</span
          ><br />
          <b>{{ point.locomotive.battery }}</b>
        </div>
      </v-row>

      <span v-if="point.locomotive.fuellevel !== 0">
        <v-row>
          <div class="col-1 pt-0 pb-0">
            <v-icon color="#00475A" size="18"> mdi-fuel </v-icon>
          </div>
          <div class="col pt-0 pb-2">
            <span>{{ $t("message.infoloc.fuellevel", { value: "default" }) }}</span
            ><br />
            <b>{{ point.locomotive.fuellevel }} %</b>
          </div>
        </v-row>
      </span>

      <span v-if="point.locomotive.status !== 'UNKNOWN'">
        <v-row>
            <div class="col-1 pt-0 pb-0">
              <v-icon color="#00475A" size="18"> mdi-power </v-icon>
            </div>
            <div class="col pt-0 pb-2">
              <span>{{ $t("message.magic.status", { value: "default" }) }}</span
              ><br />
              <b>{{
                this.$t("message.infoloc." + point.locomotive.status, {
                  value: "default",
                }) 
              }}</b><br/><b>{{formatTimestampDate(point.locomotive.__time)+" "+formatTimestampHour(point.locomotive.__time)}}</b>
            </div>
          </v-row>
        </span>
      
    </v-card-text>
  </v-card>
</template>

<script>
import {
  formatDateHour,
  formatDate,
} from "@/shared/DateHelper";

export default {
  name: "PortalGeoTooltip",
  props: ["point"],
  methods: {
    getLocale(value) {
      if (value == "Titulaire") {
        return "message.page.titular";
      }

      if (value == "Reserve") {
        return "message.page.reserve";
      }

      if (value == "Performance") {
        return "message.page.performance";
      }

      if (value == "Spot") {
        return "message.page.spot";
      }
    },

    getValue(value) {
      if (value) {
        return "message.page.available";
      }
      return "message.page.maintenance";
    },

    formatTimestampDate(value) {
      return formatDate(value);
    },

    formatTimestampHour(value) {
      return formatDateHour(value);
    },

  },
};
</script>

<style scoped>
.tooltip {
  width: 180px;
  color: #00475a;
  display: block;
  margin: 0px;
}

.portal-deep-blue-bg {
  height: 40px;
  color: #fff;
  font-size: 14px;
  padding-top: 3px;
}
span,
b {
  color: #00475a;
  font-size: 12px;
  margin: 0px;
}
</style>
